import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"

interface Signature {
  Args: {
    lesson: CardStack
    lessonTitleClass?: string
    showOddMessageIfCardsAreNull?: boolean
    /**
     * Flag to tweak reactivity when we're passed a version of a lesson
     * instead of an actual lesson.
     * Needed for React.
     */
    isVersion?: boolean
  }
}

export default class LessonSimpleReadOnlyComponent extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::LessonSimpleReadOnly": typeof LessonSimpleReadOnlyComponent
  }
}
